import type { Position } from '@/types';

export const ARENA_PLAYER_START_POSITION: Position = {
  x: 100,
  y: 460,
};

export const getArenaPlayerStartPosition = () => ({
  ...ARENA_PLAYER_START_POSITION,
});
